"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function ServiceProviderDisclosures() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "stepper-end", children: [(0, jsx_runtime_1.jsx)("p", { children: "**Not a final credit decision." }), (0, jsx_runtime_1.jsxs)("p", { children: ["- Alphaeon Credit Card Accounts are issued by Comenity Capital Bank", ' ', (0, jsx_runtime_1.jsx)("br", {}), "Credit card offers are subject to credit approval."] })] }));
}
exports.default = (0, react_1.memo)(ServiceProviderDisclosures);
